export default "__VITE_ASSET__Bx3GK2h1__"